import DummyResource from 'assets/images/dummy_resource.png';

export const DummyResourceImg = DummyResource;
export const EMPTY_RESOURCE = { url: '', text: '', image: '' };

export const RESOURCES_TITLES = [
  'Scaling Software: Forging Excellence Through Fundamentals',
  'Scaling Software from $1 to $20M',
  'The ICONIQ Growth Enterprise Five',
  'The Software Glossary',
  '2025 Path to IPO',
  'Accelerating the Pace of Innovation: Driving Growth & Efficiency in 2025',
  'Looking Back at 2024',
  '2024 State of AI Report',
  'Leveraging Channel Partnerships to Reignite Growth',
  'The State of Go-to-Market in 2024',
  'Marketing Budgets & Productivity',
  'GTM Reporting Guide',
  'R&D Compensation & Incentives',
  'Sales Compensation',
  'The R&D Reporting Guide',
  'The Go-to-Market Reporting Guide',
  'Building Go-to-Market Teams',
  'Building Product and Engineering Teams'
];
